export const ToolsConstants = {
  INDEX_CONTENT_TEXT: {
    PRODUCT_HEADER: "Products",
    ADD_NEW_PRODUCTS: "Add New Product",
    ADD_NEW_CATEGORIES: "Add New Category",
    CATEGORY: "Category",
    TYPE_OF_PRODUCT: "Type of Product",
    PRODUCT: "Product",
    MANAGE_REQUEST: "Manage Request",
    OVERVIEW: "Overview",
    SUB_PRODUCTS: "Sub Products",
    REQUEST: "Request",
  },

  FORM: {
    PRODUCT: {
      ADD_PRODUCT: "Add Product",
      UPDATE_PRODUCT: "Update Product",
      SAVE_PRODUCT: "Save Product",
      ADD_PRODUCT_SUCCESS: "Product added successfully",
      UPDATE_PRODUCT_SUCCESS: "Product updated successfully",
      PRODUCT_QUANTITY_ADJUSTED: "Product quantity adjusted successfully",
      ADJUST_QUANTITY: "Adjust Quantity",
      ADD_QTY: "Add Qty",
      REDUCE_QTY: "Reduce Qty",
    },
    CATEGORY: {
      ADD_CATEGORY: "Add Category",
      UPDATE_CATEGORY: "Update Category",
      SAVE_CATEGORY: "Save Category",
    },
    SUB_PRODUCT: {
      SAVE_SUB_PRODUCT: "Save Sub Product",
      UPDATE_SUB_PRODUCT: "Update Sub Product",
      CREATED_SUB_PRODUCT_SUCCESS: "Sub Product created successfully",
      UPDATED_SUB_PRODUCT_SUCCESS: "Sub Product updated successfully",
      DELETE_SUB_PRODUCT_SUCCESS: "Sub Product deleted successfully",
    },
    ITEMS: {
      ADD_ITEM: "Add Items",
      UPDATE_ITEM: "Update Items",
      SAVE_ITEM: "Save Items",
      ADD_BULK_ITEMS: "Add Bulk Items",
      ADD_ROW: "Add Row",
      ADD_FIVE_ROW: "Add 5 Row",
      ADDED_ITEMS_SUCCESS: "Items added successfully",
      UPDATED_ITEMS_SUCCESS: "Item updated successfully",
      DELETED_ITEMS_SUCCESS: "Item deleted successfully",
      ITEM_DELETE_CONFIRMATION:
        "Are you sure you want to delete this item? This action cannot be undone.",
      ITEM_STATUS_ALREADY_SET: "Item status is already set to this value",
    },
    RETURN_REQUEST: {
      APPROVE_REQUEST: "Approve Request",
      TOAST_SUCCESS: "Return request approved successfully",
    },
  },
  PRODUCTS: {
    HEADER: "Products",
    ITEMS: "Items",
    ADD_PRODUCT: "Add Product",
    UPDATE_PRODUCT: "Update Product",
    SAVE_PRODUCT: "Save Product",
    SUBPRODUCTS: "Sub Products",
    ADD_SUB_PRODUCT: "Add Sub Product",
    SAVE_SUB_PRODUCT: "Save Sub Product",
    TOTAL_SUB_PRODUCTS: "Total Sub Products",
    AVAILABLE: "Available",
    SENT_TO_SITE: "Sent to Site",
    UNDER_REPAIR: "Under Repair",
    ON_SITE: "On Site",
    CONSUMNED: "Consumed",
    DAMAGED: "Damaged",
    LOST: "Lost",
    USED: "Used",
    FILES_AND_ATTACHMENTS: "Files and Attachments",
    TOTAL_ITEMS: "Total Items",
    ITEMS_CONSUMED: "The item is consumed",
  },
  REQUEST: {
    RETURN_REQUEST: {
      TITLE: "Return Request",
      NO_RETURN_REQUEST_PRODUCTS: "No Return Request Products ",
      REJECT_REQUEST: {
        SUB_TITLE: "Are you sure you want to reject the request by",
        BTN_LABEL: "Yes, Reject",
        PLACEHOLDER: "Enter reason for request cancellation",
        INPUT_LABEL: "Reason",
        SUCCESS_MESSAGE: "Request rejected successfully",
      },
    },

    TRANSFER_REQUEST: {
      TITLE: "Transfer Request",
      TRANSFER_REQUEST_PRODUCTS: "Transfer Request Products",
      ADD: {
        label: " Transfer Tools",
      },
      TRANSFER_TOOLS_FORM: {
        TITLE: "Transfer Tools",
        ADD: {
          label: "Transfer Tools",
        },
        TOAST_MESSAGES: {
          TRANSFER_TOOLS_SUCCESS: "Tools transferred successfully",
        },
      },
    },
    AWAITING: {
      TITLE: "Awaiting Request",
      AWAITING_REQUEST_PRODUCTS: "Awaiting Request Products",
    },
    PRODUCT_REQUEST: {
      TITLE: "Product Request",
      PRODUCT_REQUEST_PRODUCTS: "Product Request Products",
      ACCEPTED_SUCCESS: "Request accepted successfully",
      REJECTED_SUCCESS: "Request rejected successfully",
      ADD: {
        label: " Request Products",
      },
      PRODUCT_REQUEST_FORM: {
        TITLE: "Product Request",
        ADD: {
          label: "Request Products",
        },
        TOAST_MESSAGES: {
          PRODUCT_REQUEST_SUCCESS: "Product request created successfully",
        },
      },
    },
  },
};

export const ToolsKeys = {
  PRODUCT_ASSIGNMENT_ID: "product_assignment_id",
  SUB_PRODUCT_ID: "sub_product_id",
  SUB_PRODUCT_ITEM_ID: "sub_product_item_id",
  tool_id: "tool_id",
  SUB_PRODUCT_NAME: "sub_product_name",
  RETURN_REQUEST_ID: "return_request_id",
  PRODUCT_REQUEST_ID: "product_request_id",
};
